import { render, staticRenderFns } from "./addTypeModal.vue?vue&type=template&id=141c74b2&scoped=true"
import script from "./addTypeModal.vue?vue&type=script&lang=js"
export * from "./addTypeModal.vue?vue&type=script&lang=js"
import style0 from "./addTypeModal.vue?vue&type=style&index=0&id=141c74b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141c74b2",
  null
  
)

export default component.exports